import React from "react";
import PropTypes from "prop-types";
import "./PricingCard.css";
import CheckIcon from "@mui/icons-material/Check";

const formatFeatureLabel = (feature) => {
  if (!feature || typeof feature !== "string") return feature;
  return feature
    .split(/[_\s]+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

const PricingCard = ({
  imageSrc,
  title,
  price,
  originalPrice, // <-- New
  priceLabel,
  description,
  features,
  buttonText,
  onButtonClick,
  isHighlighted,
  yearlyHeading,
  link,
}) => {
  return (
    <div className={`pricing-card ${isHighlighted ? "highlighted" : ""}`}>
      <div className="pricing-image">
        <img src={imageSrc} alt={`${title} icon`} />
      </div>
      <div className="pricing-header">
        <h3 className="pricing-title">{title}</h3>
        <div className="pricing-price-row">
          <span className="pricing-price">{price}</span>
          <div style={{ display: "flex", flexDirection: "column", gap: "0px" }}>
            {originalPrice && (
              <span className="pricing-original-price">{originalPrice}</span>
            )}
            {priceLabel && (
              <span className="pricing-price-label">{priceLabel}</span>
            )}
          </div>
        </div>
        <p className="pricing-description">{description}</p>
      </div>

      <p className="pricing-card-line"></p>
      {yearlyHeading && (
        // <p className="pricing-yearly-heading">{yearlyHeading}</p>
        <>
          <p
            className="pricing-yearly-heading"
            dangerouslySetInnerHTML={{ __html: yearlyHeading || "" }}
          ></p>
          {/* <p>{description}</p> */}
        </>
      )}
      <ul className="pricing-features">
        {features.map((feature, index) => (
          <li key={index} className="pricing-feature">
            <span className="pricing-feature-icon">
              <CheckIcon sx={{ fontSize: 12 }} />
            </span>
            {formatFeatureLabel(feature)}
          </li>
        ))}
      </ul>
      {yearlyHeading && (
        // <p className="pricing-yearly-heading">{yearlyHeading}</p>
        <>
          <p className="pricing-link">{link}</p>
          {/* <p>{description}</p> */}
        </>
      )}
      <button className="pricing-button" onClick={onButtonClick}>
        {buttonText}
      </button>
    </div>
  );
};

PricingCard.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  // features: PropTypes.arrayOf(PropTypes.string).isRequired,
  features: PropTypes.arrayOf(PropTypes.string).isRequired,
  buttonText: PropTypes.string.isRequired,
  onButtonClick: PropTypes.func.isRequired,
  isHighlighted: PropTypes.bool,
  yearlyHeading: PropTypes.string,
};

PricingCard.defaultProps = {
  isHighlighted: false,
};

export default PricingCard;
